const tableHeaders = [
  {
    label: 'name',
    key: 'name',
    sortable: false,
  },
  {
    label: 'form-type',
    key: 'formType',
    sortable: false,
  },
  {
    label: 'form-layout',
    key: 'layout',
    sortable: false,
  },
  {
    label: 'schedule',
    key: 'period',
    sortable: false,
  },
  {
    label: 'status',
    key: 'status',
    sortable: false,
  },
  {
    label: 'view-edit',
    key: 'view',
    sortable: false,
  },
  {
    label: 'copy',
    key: 'copy',
    sortable: false,
  },
  {
    label: 'delete',
    key: 'delete',
    sortable: false,
  },
];

export default () => tableHeaders;
